import React from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  styled,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupAddIcon from "@mui/icons-material/GroupAdd";


const OptionCard = styled(Card)(({ theme, selected }) => ({
  flex: 1,
  borderRadius: theme.spacing(2),
  border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  backgroundColor: selected ? theme.palette.action.hover : "#F3EDFD",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[4],
  },
}));

const IconWrapper = styled(Box)(({ theme, variant }) => ({
  width: 50,
  height: 50,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(3),
  backgroundColor:
    variant === "primary"
      ? theme.palette.primary.main
      : theme.palette.secondary.light,
  color:
    variant === "primary"
      ? theme.palette.primary.contrastText
      : theme.palette.secondary.main,
}));
const UserSelectionOptions = ({ setUserType, userType }) => {
  return (
    <Box sx={{ mt: -3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ px: 1, textAlign: "center" }}
        >
          Select the type of user account you want to create.
        </Typography>

        <Box display="flex" gap={3} mt={2}>
          {/* Existing Employee Option */}
          <OptionCard
            selected={userType === "existing"}
            onClick={() => setUserType("existing")}
            elevation={0}
          >
            <CardActionArea
              sx={{
                px: 2,
                py: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <IconWrapper variant="primary">
                <PersonAddIcon sx={{ fontSize: 25 }} />
              </IconWrapper>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                Existing Employee
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a user account for an employee who already exists in your organization.
              </Typography>
            </CardActionArea>
          </OptionCard>

          {/* External User Option */}
          <OptionCard
            selected={userType === "external"}
            onClick={() => setUserType("external")}
            elevation={0}
          >
            <CardActionArea
              sx={{
                px: 2,
                py: 2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <IconWrapper variant="primary">
                <GroupAddIcon sx={{ fontSize: 25 }} />
              </IconWrapper>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                External User
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Create a user account for someone outside your organization.
              </Typography>
            </CardActionArea>
          </OptionCard>
        </Box>
    </Box>
  );
};

export default UserSelectionOptions;
